import { render, staticRenderFns } from "./CreatorContent.vue?vue&type=template&id=16c35da7&scoped=true"
import script from "./CreatorContent.vue?vue&type=script&lang=js"
export * from "./CreatorContent.vue?vue&type=script&lang=js"
import style0 from "./CreatorContent.vue?vue&type=style&index=0&id=16c35da7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c35da7",
  null
  
)

export default component.exports